import { useState } from "react";
import * as FeatherIcon from "react-feather";
import TextWithTooltip from "./TextWithTooltip";

function SavedContactTab({ content, onDelete,defaultList = false, list_type = 'global_contacts'}) {
  const [hover, setHover] = useState(false);
  const [trashHover, setTrashHover] = useState(false);

  const count = (list_type="global_accounts") ? (content?.company_ids?.length || 0) : (content?.contacts?.length || 0);
  const name = content?.name || "No Name";
  const delete_id = (list_type="global_accounts") ? (content?.name || '') : (content?.id || '')

  const renderName =
    name.length > 25 ? <TextWithTooltip text={name} /> : name;

  return (
    <div
      className="sgc-tab-item"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => {
        setHover(false);
        setTrashHover(false);
      }}
    >
      <div className="sgc-tab-row">
        <span className="sgc-tab-title">
          {renderName}
          {defaultList && (
          <span
            style={{
              color: "#95a5beff",
              fontSize: "10px",
              marginLeft:"5px",
              fontWeight: 500,
            }}
          >
            (By Default)
          </span>
        )}
        </span>
        
        {/* DEFAULT: show count */}
        {!hover && count > 0 && (
          <span className="sgc-tab-count">({count})</span>
        )}

        {/* HOVER STATE: show trash icon */}
        {hover && !defaultList&& (
          <span
            className="sgc-tab-trash"
            onMouseEnter={() => setTrashHover(true)}
            onMouseLeave={() => setTrashHover(false)}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onDelete?.(delete_id);
            }}
          >
            <FeatherIcon.Trash2
              size={15}
              color={trashHover ? "red" : "#64748b"}
            />
          </span>
        )}
      </div>
    </div>
  );
}

export default SavedContactTab;
